import { render, staticRenderFns } from "./NativeFullscreen.vue?vue&type=template&id=9a72d688&lang=pug&"
import script from "./NativeFullscreen.vue?vue&type=script&lang=ts&"
export * from "./NativeFullscreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports